const FORMATTING_CHARS_REGEX = /[\s　\-‐‑‒–—―()（）.．]/g;

/**
 * 表記ゆれを除去し、国内形式（0 始まり）の数字列に変換する。
 * 変換できない場合は null。
 */
const toJapaneseDomesticDigits = (value: string): string | null => {
  const nfkc = value.normalize('NFKC');
  let compact = nfkc.replace(FORMATTING_CHARS_REGEX, '');

  if (compact.startsWith('+81')) {
    compact = `0${compact.slice(3).replace(/\D/g, '')}`;
  } else {
    const digitsOnly = compact.replace(/\D/g, '');
    if (digitsOnly.length === 0) return null;
    if (digitsOnly.startsWith('81') && digitsOnly.length >= 11) {
      compact = `0${digitsOnly.slice(2)}`;
    } else {
      compact = digitsOnly;
    }
  }

  if (!/^\d+$/.test(compact)) return null;
  return compact.length > 0 ? compact : null;
};

/**
 * 先頭 0 欠損を含む国内電話番号候補に 0 を付与する。
 * 10/11 桁（0 始まり）または 9/10 桁（0 欠損）のみ対象。
 */
const restoreLeadingZero = (digits: string): string | null => {
  if (/^0\d{9}$/.test(digits)) return digits;
  if (/^0\d{10}$/.test(digits)) return digits;
  if (/^\d{9}$/.test(digits)) return `0${digits}`;
  if (/^\d{10}$/.test(digits)) return `0${digits}`;
  return null;
};

/**
 * 日本国内電話番号を正規化する（数字のみ、先頭 0 の復元）。
 * 変換できない場合は trim + NFKC した元値を返す（normalizeDate と同様）。
 */
export const normalizePhoneNumber = (value: string): string => {
  const trimmed = value.trim();
  if (trimmed === '') return trimmed;

  const digits = toJapaneseDomesticDigits(trimmed);
  if (digits === null) {
    return trimmed.normalize('NFKC');
  }

  const restored = restoreLeadingZero(digits);
  if (restored !== null) {
    return restored;
  }

  return trimmed.normalize('NFKC');
};
